import HomePage from "../pages/home/HomePage";
import SnaPage from "../pages/sna/SnaPage";
import GisPage from "../pages/gis/GisPage";
import HelpPage from "../pages/help/HelpPage";
import LoginPage from "../pages/loginSignup/LoginPage";
import LogoutPage from "../pages/logout/LogoutPage";
import SignUpPage from "../pages/loginSignup/SignUpPage";
import ShopPage from "../pages/shop/ShopPage";
import UserSettingPage from "../pages/userSetting/UserSettingPage";
import AdminSettingPage from "../pages/adminSetting/AdminSettingPage";
import RootSettingPage from "../pages/rootSettingPage/RootSettingPage";
import ErrorPage from "../pages/error/ErrorPage";
import SupportPage from "../pages/error/SupportPage";
import PrivacyPage from "../pages/privacy/PrivacyPage";
import ServicePage from "../pages/service/ServicePage";
import InvitePage from "../pages/invite/InvitePage";
//
import authority from "./App-authority";
//
import { ROUTE_NAME, ROUTE_PATH } from "./CONSTANTS";
//
import featureDisplay from "../common/utils/featureDisplay";

// HTML Header: Nav Bar
// public: 開發中的頁面 或 關閉的頁面, public 設為 false
export const menus = {
  menuLeft: [
    // {
    //   id: "menu-left-01",
    //   name: ROUTE_NAME.Home,
    //   path: "/",
    //   public: true,
    //   authority: authority.Home,
    // },
    // {
    //   id: "menu-left-11",
    //   name: ROUTE_NAME.Sna,
    //   path: "/",
    //   public: true,
    //   authority: authority.Home,
    // },
  ],
  menuRight: [
    // showOnLogin: user login 時，是否要顯示
    {
      id: "menu-right-01",
      name: ROUTE_NAME.LogIn,
      path: ROUTE_PATH.LogIn,
      public: true,
      authority: authority.LogIn,
      showOnLogin: false,
    },
    {
      id: "menu-right-02",
      name: ROUTE_NAME.LogOut,
      path: ROUTE_PATH.LogOut,
      public: true,
      authority: authority.LogOut,
      showOnLogin: true,
    },
  ],
};

// authority: 使用者是否可以進入該頁面由 authority 控制
// public: 開發中的頁面 或 關閉的頁面, public 設為 false
export const routes = [
  // 0x: landing
  {
    id: "route-01",
    path: ROUTE_PATH.Home,
    name: ROUTE_NAME.Home,
    public: true,
    element: HomePage,
    authority: authority.Home,
  },
  // 1x: sna
  {
    id: "route-11",
    path: ROUTE_PATH.Sna,
    name: ROUTE_NAME.Sna,
    public: true,
    element: SnaPage,
    authority: authority.Sna,
  },
  // 2x: gis
  {
    id: "route-21",
    path: ROUTE_PATH.Gis,
    name: ROUTE_NAME.Gis,
    public: featureDisplay(process.env.REACT_APP_GIS_PUBLIC),
    element: GisPage,
    authority: authority.Gis,
  },
  // 3x: info, help
  {
    id: "route-31",
    path: ROUTE_PATH.Help,
    name: ROUTE_NAME.Help,
    public: true,
    element: HelpPage,
    authority: authority.Help,
  },
  {
    id: "route-32",
    path: ROUTE_PATH.ServicePage,
    name: ROUTE_NAME.ServicePage,
    public: true,
    element: ServicePage,
    authority: authority.ServicePage,
  },
  {
    id: "route-33",
    path: ROUTE_PATH.PrivacyPage,
    name: ROUTE_NAME.PrivacyPage,
    public: true,
    element: PrivacyPage,
    authority: authority.PrivacyPage,
  },
  // 4x: auth
  {
    id: "route-41",
    path: ROUTE_PATH.LogIn,
    name: ROUTE_NAME.LogIn,
    public: true,
    element: LoginPage,
    authority: authority.LogIn,
  },
  {
    id: "route-42",
    path: ROUTE_PATH.LogOut,
    name: ROUTE_NAME.LogOut,
    public: true,
    element: LogoutPage,
    authority: authority.LogOut,
  },
  {
    id: "route-43",
    path: ROUTE_PATH.Signup,
    name: ROUTE_NAME.Signup,
    public: true,
    element: SignUpPage,
    authority: authority.Signup,
  },
  {
    id: "route-44",
    path: ROUTE_PATH.InvitePage,
    name: ROUTE_NAME.InvitePage,
    public: true,
    element: InvitePage,
    authority: authority.InvitePage,
  },
  // 5x: shop
  {
    id: "route-51",
    path: ROUTE_PATH.Shop,
    name: ROUTE_NAME.Shop,
    public: featureDisplay(process.env.REACT_APP_UPGRADE_TO_PRO_PUBLIC),
    element: ShopPage,
    authority: authority.Shop,
  },
  // 6x: setting
  {
    id: "route-61",
    path: ROUTE_PATH.UserSetting,
    name: ROUTE_NAME.UserSetting,
    public: featureDisplay(process.env.REACT_APP_USER_SETTING_PUBLIC),
    element: UserSettingPage,
    authority: authority.UserSetting,
  },
  {
    id: "route-62",
    path: ROUTE_PATH.AdminSetting,
    name: ROUTE_NAME.AdminSetting,
    public: true,
    element: AdminSettingPage,
    authority: authority.AdminSetting,
  },
  {
    id: "route-63",
    path: ROUTE_PATH.RootSetting,
    name: ROUTE_NAME.RootSetting,
    public: true,
    element: RootSettingPage,
    authority: authority.RootSetting,
  },
  // 7x: error, support
  {
    id: "route-71",
    path: ROUTE_PATH.ErrorPage,
    name: ROUTE_NAME.ErrorPage,
    public: true,
    element: ErrorPage,
    authority: authority.ErrorPage,
  },
  {
    id: "route-72",
    path: ROUTE_PATH.SupportPage,
    name: ROUTE_NAME.SupportPage,
    public: true,
    element: SupportPage,
    authority: authority.SupportPage,
  },
];

// 當使用者不登入, 開放的頁面
export const routesPublicNotLogin = [
  ROUTE_PATH.Home,
  // ROUTE_PATH.Sna,
  // ROUTE_PATH.Gis,
  // ROUTE_PATH.Help,
  ROUTE_PATH.LogIn,
  ROUTE_PATH.LogOut,
];
